import { Injectable } from '@angular/core';
import { Routes, Router, Route } from '@angular/router';

@Injectable()
export class RoutesService {
    routesOwner: Routes = [    
        {
            path: '',
            //component: LoginComponent,
            data:{ title: 'Login' }
        },
        {
            data:{ title: 'Anagrafiche' }
        }
    ];
    getRoutesOwner(): Routes {
        function updateRoutingInfo(routesXX: Routes, path: string) {
            routesXX.forEach(route => {               
                if(!route.data) { return; }
               // if(route.data.path=='') { return; }
                //alert(route.path);                
                const fullLink = [path, route.path].join('/');
                route.data.link = fullLink;
                if(route.children) {
                    updateRoutingInfo(route.children, fullLink);
                }
            });
        }
 
        updateRoutingInfo(this.routesOwner, '');
        console.log("ECCO il routing ",this.router.config);
        return this.router.config;
    }
    
    getRoutes(): Routes {        
        function updateRoutingInfo(routes: Routes, path: string) {
            routes.forEach(route => {               
                if(!route.data) {return; }
               // if(route.data.path=='') { return; }
                //alert(route.path);
                const fullLink = [path, route.path].join('/');
                route.data.link = fullLink;
                // alert(fullLink);
                if(route.children) {
                    updateRoutingInfo(route.children, fullLink);
                }
            });
        }

        updateRoutingInfo(this.router.config, '');
        console.log("ECCO il routing ",this.router.config);
        return this.router.config;
    }

    constructor(private router: Router) { }
}
